import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { IssueModel } from 'src/app/models/api/issue.model';
import { InventoryResourceGraph } from 'src/app/models/api/inventoryResource.model';
import { SortColumn } from 'src/app/models/sortColumn.model';
import { IssuesHttpService } from 'src/app/services/httpServices/issues/issues-http.service';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';
import { JsonHalCollection } from 'src/app/models/api/jsonhal.model';

@Injectable({
  providedIn: 'root',
})
export class IssuesDataService {
  constructor(
    private readonly _http: HttpClient,
    private readonly _issuesHttpService: IssuesHttpService
  ) {}

  public getIssuesData(
    sort?: SortColumn[],
    filters?: ISelectedFilters,
    pageNumber = 1
  ): Observable<JsonHalCollection<IssueModel>> {
    return this._issuesHttpService.getIssues(sort, filters, 50, pageNumber);
  }

  public getIssueRelationsGraph(issueId: string): Observable<InventoryResourceGraph> {
    return this._http
      .get<{ issueId: string; graphData: InventoryResourceGraph }[]>('assets/mockData/issueGraphMockData.json')
      .pipe(
        map((data: { issueId: string; graphData: InventoryResourceGraph }[]) => {
          const issueData = data.find((item) => item.issueId === issueId);
          if (!issueData) {
            throw new Error(`Graph data for issue with id ${issueId} not found`);
          }
          const graphData = issueData.graphData;

          if (Array.isArray(graphData.graphNodes) && graphData.graphNodes.length > 0) {
            graphData.graphNodes[0].resource = {
              ...graphData.graphNodes[0].resource,
              id: issueId,
            };
          }
          return graphData;
        })
      );
  }
}
